// extracted by mini-css-extract-plugin
export default {"hot_box":"index_hot_box_OH3P-","hot_title":"index_hot_title_3N8x6","newsStream_box":"index_newsStream_box_UAQOT"};